module.exports = __webpack_public_path__ + "img/Butterfly_00280.f56cf0d2.png";